import { render, staticRenderFns } from "./revisitStatus.vue?vue&type=template&id=93f44ed8&scoped=true"
import script from "./revisitStatus.vue?vue&type=script&lang=js"
export * from "./revisitStatus.vue?vue&type=script&lang=js"
import style0 from "./revisitStatus.vue?vue&type=style&index=0&id=93f44ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f44ed8",
  null
  
)

export default component.exports